import { ISettingsStore } from './store';

export const SET_SETTINGS = 'SET_SETTINGS';
export type SET_SETTINGS = typeof SET_SETTINGS;
export interface ISetSettings {
  payload: ISettingsStore;
  type: SET_SETTINGS;
}

export const SET_VIEWTYPE = 'SET_VIEWTYPE';
export type SET_VIEWTYPE = typeof SET_VIEWTYPE;
export interface ISetViewType {
  payload: string;
  type: SET_VIEWTYPE;
}

export const SET_LINKS_PER_PAGE = 'SET_LINKS_PER_PAGE';
export type SET_LINKS_PER_PAGE = typeof SET_LINKS_PER_PAGE;
export interface ISetLinksPerPage {
  payload: number;
  type: SET_LINKS_PER_PAGE;
}

export type ISettingsActions = ISetSettings | ISetViewType | ISetLinksPerPage;



// WEBPACK FOOTER //
// ./src/services/settings/actionTypes.ts